import React from "react";
import { Country } from "country-state-city";

interface CurrencyFlagProps {
  currency?: string;
  className?: string;
  fallbackFlag?: string;
}

const CURRENCY_TO_ISO_OVERRIDE: Record<string, string> = {
  USD: "US",
  NGN: "NG",
  GBP: "GB",
  EUR: "EU",
  KES: "KE",
  CAD: "CA",
  GHS: "GH",
  ZAR: "ZA",
  AUD: "AU",
  JPY: "JP",
  CNY: "CN",
  CHF: "CH",
  AED: "AE",
};

export const getCountryIsoForCurrency = (currency?: string): string => {
  if (!currency) return "";
  const normalized = currency.trim().toUpperCase();
  if (CURRENCY_TO_ISO_OVERRIDE[normalized]) {
    return CURRENCY_TO_ISO_OVERRIDE[normalized];
  }
  const matched = Country.getAllCountries().find(
    (c) => c.currency?.toUpperCase() === normalized
  );
  return matched?.isoCode || "";
};

export const CurrencyFlag: React.FC<CurrencyFlagProps> = ({
  currency,
  className = "size-5",
  fallbackFlag,
}) => {
  const isoCode = getCountryIsoForCurrency(currency).toLowerCase();

  if (!isoCode) return null;

  return (
    <span
      className={`overflow-hidden flex items-center justify-center rounded-full bg-primary-90 shrink-0 ${className}`}
    >
      <img
        src={`https://flagcdn.com/w40/${isoCode}.png`}
        alt={currency}
        className="h-full w-full object-cover rounded-full"
        onError={(e) => {
          // If image fails to load, replace with emoji fallback or text
          if (fallbackFlag) {
            (e.target as HTMLElement).style.display = "none";
          }
        }}
      />
    </span>
  );
};

